import { AdminApi } from 'stylemix-vue-admin'

export default class PricePeriodApi extends AdminApi {
  constructor(vehicleId, parameters) {
    super(`vehicles/${vehicleId}/price-periods`, parameters)
  }
}
